import { Descriptions } from "@/components/v2";
// import { Button } from "@rumbledirect/ui";
import {
  Button,
  Empty,
  Image,
  Popconfirm,
  Space,
  type DescriptionsProps,
} from "antd";
import { Link } from "react-router-dom";
import { UseMutationResult } from "@tanstack/react-query";
import { ReplacementTransportOption } from "@rumble-it/common-lib/types/models/ReplacementTransportOption.interface";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Card } from "@rumbledirect/ui";

interface ReplacementTransportOptionDetailCardProps {
  replacementTransportOption?: ReplacementTransportOption;
  isLoading?: boolean;
  deleteMutation?: UseMutationResult<null, Error, void, unknown>;
}

export const ReplacementTransportOptionDetailCard = ({
  replacementTransportOption,
  isLoading,
  deleteMutation,
}: ReplacementTransportOptionDetailCardProps) => {
  return (
    <Card
      loading={isLoading}
      className="w-full"
      title="Vervangend vervoer optie"
      extra={
        <Space>
          <Link
            to={`/replacement-transport/options/${replacementTransportOption?.id}/edit`}
          >
            <Button icon={<EditOutlined />} />
          </Link>
          <Popconfirm
            title="Vervangend vervoer optie verwijderen"
            description="Weet je zeker dat je deze vervangend vervoer optie wil verwijderen?"
            onConfirm={() => deleteMutation?.mutate()}
            okText="Ja"
            cancelText="Nee"
          >
            <Button
              loading={deleteMutation?.isPending}
              danger
              icon={<DeleteOutlined />}
            />
          </Popconfirm>
        </Space>
      }
    >
      {(() => {
        const items: DescriptionsProps["items"] = [
          {
            label: "Naam",
            children: replacementTransportOption?.title ?? null,
          },
          {
            label: "Beschrijving",
            children: replacementTransportOption?.description || "-",
          },
          {
            label: "Headerafbeelding",
            children:
              replacementTransportOption?.headerImage &&
              replacementTransportOption.headerImage.contentUrl ? (
                <Image
                  width={240}
                  src={replacementTransportOption.headerImage.contentUrl}
                  alt="Headerafbeelding"
                />
              ) : (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Geen afbeelding"
                />
              ),
          },
        ];
        return <Descriptions items={items} />;
      })()}
    </Card>
  );
};
